import { useQuery } from '@tanstack/react-query';
import useAuthenticatedUserClient from 'clients/useAuthenticatedUserClient';
import { queryClient } from 'contexts/QueryClient';

export const usageKey = 'get-company-usage';

export type PlanUsageRequestProps = Readonly<{
  startDate: Date;
  endDate: Date;
  companyId?: string;
}>;
export default function useCompanyPlanUsage(request: PlanUsageRequestProps) {
  const { company } = useAuthenticatedUserClient();
  return useQuery({
    queryKey: [usageKey, request.companyId, request.startDate, request.endDate],
    queryFn: async () => {
      return await company.getCompanyUsageMetrics({
        startTime: request.startDate,
        endTime: request.endDate,
      });
    },
  });
}

export const invalidateCompanyPlanUsage = (companyId?: string) => {
  const queryKey = companyId ? [usageKey, companyId] : [usageKey];
  return queryClient.invalidateQueries({ queryKey });
};
